// The specialty types CMS allows the telehealth threshold credit for, as listed on the HPMS
// Submit Network page (NMM Plan User Guide 1.3.2 and Figure 4). The plan ticks the ones it
// indicates; those receive the 10 point credit in every county of the submission.
export const TELEHEALTH_SPECIALTIES = [
  ['S03', 'Primary Care'], ['007', 'Allergy and Immunology'], ['008', 'Cardiology'], ['011', 'Dermatology'],
  ['012', 'Endocrinology'], ['013', 'ENT / Otolaryngology'], ['016', 'Gynecology, OB / GYN'], ['017', 'Infectious Diseases'],
  ['018', 'Nephrology'], ['019', 'Neurology'], ['023', 'Ophthalmology'], ['029', 'Psychiatry'],
  ['036', 'Clinical Psychology'], ['037', 'Clinical Social Work'], ['068', 'Outpatient Behavioral Health']
];

export function TelehealthSpecialtyPicker({ value, onChange, className = '', light = false }) {
  const set = new Set(value || []);
  const toggle = (code) => { const next = new Set(set); if (next.has(code)) next.delete(code); else next.add(code); onChange([...next]); };
  const text = light ? 'text-white/90' : 'text-slate-800';
  return (
    <div className={`grid sm:grid-cols-3 gap-x-4 gap-y-1 ${className}`}>
      {TELEHEALTH_SPECIALTIES.map(([code, name]) => (
        <label key={code} className={`flex items-center gap-2 text-[12px] ${text}`}>
          <input type="checkbox" checked={set.has(code)} onChange={() => toggle(code)} /> {name} ({code})
        </label>
      ))}
    </div>
  );
}
